import React, { useEffect, useState, useCallback } from 'react'
import { Box, Text } from '@usap/uicomponents'
import { StarCount } from '@usap/widgets'
import useReviews from '../../../../../hooks/useReviews'

export default function ReviewsRatings(props) {
  const { id } = props
  const { avgRating, reviewCount } = useReviews(id)

  return (
    <Box
      direction="row"
      align="start"
      height={{ min: '24px' }}
      className="productRating"
    >
      {avgRating !== '' && <StarCount ratings={avgRating} />}

      {reviewCount !== '' && (
        <Text
          size="xsmall"
          color="dark-2"
          alignSelf="center"
          margin={{ left: 'small' }}
        >
          {`${reviewCount} Reviews`}
        </Text>
      )}
    </Box>
  )
}
